<template>
  <div class="index_main">
    <img :src="'/static/images/'+navtable+'/smdcbj.jpg'" style="width:100%;height:100%;position:fixed;left:0;top:0;z-index:-1;"/>
    <div id="loader-wrapper">
      <div id="loader"></div>
      <div class="loader-section section-left"></div>
      <div class="loader-section section-right"></div>
      <div class="load_title">{{xznr}}</div>
    </div>

    <div class="index_sfxd" @touchmove.prevent v-if="qdxdstate">
      <div class="index_sfxd_main">
        <div class="index_sfxd_table">是否确定下单</div>
        <div class="index_sfxd_butt">
          <div @click="qdxdclick2">取消</div>
          <div @click="qdxdclick">确定</div>
        </div>
      </div>
    </div>
    <div class="index_main2" v-if="!xqstate">
      <div class="index_top">
        {{Desk}}
      </div>
      <div class="index_logo">
        <div class="index_logo1">
          <img :src="'/static/images/'+navtable+'/indexlogo.png'">
        </div>
        <div class="index_logo2"  @click="xqclick"></div>
      </div>
      <div class="index_table">
        <div class="index_table_nav" style="margin-top:.1rem;">
          <div class="index_table_navs" v-for="(item,i) in MenuType" v-if="i<5" @click="MenuState(i)">
            <div class="index_table_navbj" v-if="Menuxb==i"></div>
            <div class="index_table_navimg"
              :style="'background:url(/static/images/'+navtable+'/table'+item.StateID+'.png);background-size:100% 100%;'">
              <div class="index_table_navtext" :style="navtable=='sh'?'bottom:0;':''">{{item.TypeName}}</div>
            </div>
          </div>
        </div>
        <div class="index_table_nav" style="margin-top:.1rem;">
          <div class="index_table_navs" v-for="(item,i) in MenuType" v-if="i<10&&i>=5" @click="MenuState(i)">
            <div class="index_table_navbj" v-if="Menuxb==i"></div>
            <div class="index_table_navimg"
              :style="'background:url(/static/images/'+navtable+'/table'+item.StateID+'.png);background-size:100% 100%;'">
              <div class="index_table_navtext" :style="navtable=='sh'?'bottom:0;':''">{{item.TypeName}}</div>
            </div>
          </div>
        </div>
        <div class="index_table_nav" :style="navtable=='sh'?'margin-top:.1rem;width:105%;margin:0 -1%;':'margin-top:.1rem;'">
          <div class="index_table_navs" v-for="(item,i) in MenuType" v-if="i<14&&i>=10" @click="MenuState(i)">
            <div class="index_table_navbj" v-if="Menuxb==i"></div>
            <div class="index_table_navimg"
              :style="'background:url(/static/images/'+navtable+'/table'+(i+1)+'.png);background-size:100% 100%;'">
              <div class="index_table_navtext" :style="navtable=='sh'?'bottom:0;':''">{{item.TypeName}}</div>
            </div>
          </div>
          <div class="index_table_nav2" :style="navtable=='sh'||navtable=='yhd'?'width:28%;height:1.1rem;margin:0.2rem 0.2rem 0 0;':''">
            <img :src="'/static/images/'+navtable+'/djxd.png'" :style="navtable=='sh'||navtable=='yhd'?'width:80%;':''">
          </div>
        </div>
        <div class="index_Goods" style="margin-top:.2rem;">
          <swiper
            ref="mySwiper"
            @slideChange="onSlideChange"
            @touchStart="onSwiperTouchStart"
            @touchEnd="onSwiperTouchEnd"
            :options="swiperOptions"
          >
            <swiper-slide v-for="index in swiperQua" :key="index">
              <div class="index_Goods_swiper">
                <div class="index_Goods_Goods" v-for="(item,i) in 9" v-if="Goodslist[swiperxb*9+i]"
                  @click="goodsclick(swiperxb*9+i)">
                  <div class="index_Goods_Goods1">
                    <img :src="Goodslist[swiperxb*9+i].src" />
                  </div>
                  <div class="index_Goods_Goods2" :style="navtable=='lll'?'background:#fff;color:#000;font-weight:bold;':''">
                    <div style="transform: scale(0.8);width:125%;position:absolute;left:-12.5%;">{{Goodslist[swiperxb*9+i].Goods}}</div>
                  </div>
                  <div v-if="navtable=='sh'" style="position:absolute;top:.1rem;right:.1rem;line-height:.3rem;color:yellow;font-size:.24rem;">{{Goodslist[swiperxb*9+i].MessyPrice.toFixed(2)}}</div>
                  <div v-if="navtable=='yhd'" style="position:absolute;top:.1rem;right:.1rem;line-height:.3rem;color:yellow;font-size:.24rem;">{{Goodslist[swiperxb*9+i].MessyPrice.toFixed(2)}}</div>
                  <div v-if="navtable=='lll'" style="position:absolute;top:.1rem;right:.1rem;line-height:.3rem;color:#000;font-size:.24rem;font-weight: bold;">{{Goodslist[swiperxb*9+i].MessyPrice}}</div>
                  <div v-if="Goodslist[swiperxb*9+i].IsEmpty" style="width:1.4rem;height:.7rem;line-height:.7rem; position:absolute;top:.25rem;right:.3rem;color:red;font-size:.4rem;border-radius:.1rem;border:2px solid red;background:#fff;font-weight:bold;transform:rotate(12deg);">
                    售完
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <div :class="navtable">
        <div class="index_xhc" ref="xhc">
          <div class="index_xhc_main">
            <div v-for="(item,i) in gwclist" class="index_xhc_img" @click="deleteclick(i)">
              <img :src="item.src">
            </div>
          </div>
        </div>
      </div>
      <div class="index_xd" @click="xfxdclick" v-if="!sheetzt">

      </div>
      <div style="width:100%;height:1rem;">
		  <template v-if="navtable=='yhd'">
			  <div class="hydl" @click="hydl">会员登录</div>
		  </template>
	  </div>
    </div>
    <div class="index_main2" v-if="xqstate">
      <div class="index_top">
        {{Desk}}
      </div>
      <div class="index_cxdd">
        订单详情
      </div>
      <div class="index_biaoge">
        <div class="index_biaoge_top">
          <div class="index_biaoge_left">菜品名称</div>
          <div class="index_biaoge_right">数量</div>
        </div>
        <div class="index_biaoge_main">
          <div v-for="(item,index) in list" class="index_biaoge_main_li">
            <div class="index_biaoge_left2">
              {{item.Goods}}
            </div>
            <div class="index_biaoge_right">
              {{item.Qua}}
            </div>
          </div>
        </div>
      </div>
      <div class="index_tips">
        温馨提示:本页面仅显示菜品详情。如需呼叫/结账请在IPAD端点击相关按钮进行相关操作，谢谢。
      </div>
      <div class="index_xd2" @click="fanhuiclick">
        返回点餐页
      </div>
      <div style="width:100%;height:1.41rem;"></div>
    </div>
  </div>
</template>

<script>
  import { Dialog } from 'vant-green';
  import 'swiper/swiper-bundle.css'
  import throttle from '../../static/js/throttle.js'
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper"
  export default {
    name: 'App',
    data() {
      return {
        ShopID: "",
        DeskID: "",
        swiperOptions: {
          pagination: {
            el: '.swiper-pagination', // 分页器DOM选择器
            clickable: false, // 是否可以通过点击分页器切换幻灯片
          },
        },
        sheetzt: false,
        xqstate:false,
        gwclist: [],
        Desk:"",
        list:[],
        MenuType: [],
        Menuxb: 0,
        GoodsType: [],
        Goodslist: [],
        swiperQua: 0,
        swiperxb: 0,
        touchStartedAtEnd: false,
        touchStartedAtBeginning: false,
        lastEdgeSwitchAt: 0,
        qdxdstate: false,
        xznr:"加载中...",
        navtable:"sh"
      }
    },
    computed: {

    },
    components: {
      swiper,
      swiperSlide
    },
    methods: {
	  hydl(){
		  var url="https://c1nb.cn/S0HQQ"
		  window.open(url, '_blank')
	  },
      onSwiperTouchStart() {
        const swiper = this.$refs.mySwiper && this.$refs.mySwiper.swiper
        if (!swiper) return
        this.touchStartedAtEnd = !!swiper.isEnd
        this.touchStartedAtBeginning = !!swiper.isBeginning
      },
      onSwiperTouchEnd() {
        const swiper = this.$refs.mySwiper && this.$refs.mySwiper.swiper
        if (!swiper) return
        const now = Date.now()
        if (now - this.lastEdgeSwitchAt < 400) {
          this.touchStartedAtEnd = false
          this.touchStartedAtBeginning = false
          return
        }
        const moved = Math.abs((swiper.touches && swiper.touches.diff) || 0)
        if (moved < 60) {
          this.touchStartedAtEnd = false
          this.touchStartedAtBeginning = false
          return
        }
        const shouldGoNext = this.touchStartedAtEnd && swiper.isEnd && swiper.swipeDirection === 'next'
        const shouldGoPrev = this.touchStartedAtBeginning && swiper.isBeginning && swiper.swipeDirection === 'prev'
        this.touchStartedAtEnd = false
        this.touchStartedAtBeginning = false
        if (shouldGoNext) {
          this.lastEdgeSwitchAt = now
          requestAnimationFrame(() => this.gotoNextMenuType())
        } else if (shouldGoPrev) {
          this.lastEdgeSwitchAt = now
          requestAnimationFrame(() => this.gotoPrevMenuType())
        }
      },
      gotoNextMenuType() {
        if (!this.MenuType || this.MenuType.length === 0) return
        const nextIndex = (this.Menuxb + 1) % this.MenuType.length
        this.MenuState(nextIndex)
      },
      gotoPrevMenuType() {
        if (!this.MenuType || this.MenuType.length === 0) return
        const prevIndex = (this.Menuxb - 1 + this.MenuType.length) % this.MenuType.length
        this.MenuState(prevIndex)
      },
      deleteclick(i){
        this.gwclist.splice(i,1)
      },
      fanhuiclick:function(){
        this.xqstate=false
      },
      xqclick:function(){
        this.list =[]
        var that=this
        this.xqstate=true
        this.axios.get(this.$lujin + "/api/Default/PushOrderItems?DeskID=" + this.DeskID + "&ShopID=" + this.ShopID)
          .then((res) => {
            console.log(res)
            if(res.data.State){
              var OrderNumber=res.data.OrderNumber
              var timexb=0
              var ordertime=setInterval(()=>{
                timexb++;
                if(timexb>=20){
                  clearInterval(ordertime)
                }
                that.axios.get(that.$lujin + "/api/Default/GetOrderItems?DeskID=" + that.DeskID + "&ShopID=" + that.ShopID+"&OrderNumber="+OrderNumber)
                .then((bpq) => {
                  console.log(bpq.data)
                  if(bpq.data.State){
                    clearInterval(ordertime)
                    var sz = bpq.data.Data
                    for (var i in sz) {
                      sz[i].OpItemsTime = sz[i].OpItemsTime.replace('T', ' ');
                      sz[i].OpItemsTime = sz[i].OpItemsTime.slice(10, 19)
                    }
                    that.list = sz
                  }
                })
              },1000)
            }
        })
        return
        /*
        this.axios.get(this.$lujin + "/api/Default/cha_mx?DeskID=" + this.DeskID + "&ShopID=" + this.ShopID)
          .then((res) => {
            console.log(res)
            console.log(res.data.data.Table)
            var sz = res.data.data.Table
            for (var i in sz) {
              sz[i].OpItemsTime = sz[i].OpItemsTime.replace('T', ' ');
              sz[i].OpItemsTime = sz[i].OpItemsTime.slice(10, 19)
            }
            that.list = sz
          })*/
      },
      xfxdclick:function(){
        if(this.gwclist.length<1){
          return
        }
        this.qdxdstate=true
      },
      qdxdclick2(){
        this.qdxdstate=false
      },
      qdxdclick: throttle.throttle(function() {
        this.qdxdstate=false
        var _this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let hh = new Date().getHours();
        let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
        let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
        _this = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
        var that = this
        var data = {
          bz: "",
          zhuoid: that.DeskID,
          ShopID: that.ShopID,
          list: that.gwclist,
          OrderMen: "",
          OrderPhone: "",
          OrderAddress: "",
          PostCode: "",
          OpTime: _this,
          CompleteTime: '1900-01-01 00:00:00',
          ToshopTime: '1900-01-01 00:00:00',
          ServerMoney:0,
          SheetState:0,
          PayState: 0,
          IsPay: 0,
          UserAgent: navigator.userAgent,
        }
        console.log(data)
        //this.xznr="下单中..."
        //document.getElementById("loader-wrapper").style.display="block"
        that.axios.post(that.$lujin + "/api/Default/Place_the_order", data)
          .then(res => {
            console.log(res)
            var sheet = res.data.sheet
            if (res.data.state == true) {
              that.$refs.xhc.className="index_xhc2"
              setTimeout(()=>{
                that.$refs.xhc.className="index_xhc4"
              },1000)
              var i = 0;
              var time = setInterval(function() {
                that.axios.get(that.$lujin + "/api/Default/ddstate?SheetID=" + sheet + "&ShopID=" + that.ShopID + "&DeskID=" + that.DeskID)
                  .then(res => {
                    console.log(res.data)
                    console.log(res.data[0].State)
                    if (res.data[0].State == '1') {
                      that.$refs.xhc.className="index_xhc3"
                      setTimeout(()=>{
                        that.$refs.xhc.className="index_xhc"
                      },1000)
                      that.gwclist=[]
                      clearInterval(time)
                    }
                    if (res.data[0].State == '2') {
                      that.$refs.xhc.className="index_xhc3"
                      setTimeout(()=>{
                        that.$refs.xhc.className="index_xhc"
                        if(res.data[0].Failure=="15"){
                          Dialog.alert({
                            title: '温馨提示',
                            message: '菜品可点数量不足或菜品已经售完',
                            confirmButtonText: '确定'
                          }).then(() => {
                            const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                            const today = new Date();
                            const Week = weekDays[today.getDay()];
                            const WeekQua = today.getDay() == 0 ? 7 : today.getDay()
                            let hh = new Date().getHours()
                            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
                            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
                            var time = hh + ":" + mf + ":" + ss
                            that.axios.get(that.$lujin + '/api/Default/Goods?ShopID=' + that.ShopID + "&Week=" + Week + "&Time="+time + "&WeekQua=" + WeekQua)
                              .then(pts => {
                                console.log(pts.data)
                                that.GoodsType = pts.data
                                that.MenuState(that.Menuxb)
                            })
                          });
                        }
                      },1000)
                      clearInterval(time);
                    }
                  })
                if (i == 10) {
                  console.log(1)
                  that.axios.get(that.$lujin + "/api/Default/PosError?ShopID=" + that.ShopID + "&DeskID=" +that.DeskID + "&Content=4")
                    .then(res => {
                      console.log(res)
                      if (res.data.state == "1") {
                        document.getElementById("loader-wrapper").style.display="none"
                        clearInterval(time);
                        that.canzt = true
                        that.cancen = that.ztlist[that.pickxb].o2
                        that.$refs.xhc.className="index_xhc3"
                        setTimeout(()=>{
                          that.$refs.xhc.className="index_xhc"
                        },1000)
                      } else {
                        document.getElementById("loader-wrapper").style.display="none"
                        clearInterval(time);
                        that.$refs.xhc.className="index_xhc3"
                        setTimeout(()=>{
                          that.$refs.xhc.className="index_xhc"
                          Dialog.alert({
                            title: '温馨提示',
                            message: '下单失败请联系工作人员',
                            confirmButtonText: '确定'
                          }).then(() => {

                          });
                        },1000)
                      }
                    })
                }
                i++;
              }, 1000);
            } else {
              document.getElementById("loader-wrapper").style.display="none"
            }
          })
      }, 5000),
      goodsclick: function(xb) {
        if (this.Goodslist[xb].IsEmpty){
          return
        }
        if (this.gwclist.length >= 4) {
          return
        }
        console.log(this.Goodslist[xb])
        var obj = {
          sl: 1,
          bz: '',
          id: this.Goodslist[xb].GoodsID,
          momey: this.Goodslist[xb].MessyPrice,
          Goods: this.Goodslist[xb].Goods,
          TwoGoods: this.Goodslist[xb].TwoGoods,
          ThreeGoods: this.Goodslist[xb].ThreeGoods,
          IsBuffetGoods: 0,
          addmomey: 0,
          FromID: 0,
          IsChild:false,
          isRoot:false,
          zf:"0,0,0,0,0,0,0,0",
          zuofa1: "",
          zuofa2: "",
          zuofa3: "",
          unit:"",
          cm:0,
          MinShare: 0,
          getTime: (new Date()).getTime(),
          MaxQuas: 0,
          src: this.Goodslist[xb].src,
        }
        this.gwclist.push(obj)
        console.log(this.gwclist)
      },
      onSlideChange: function() {
        //console.log(this.$refs.mySwiper.swiper.activeIndex)
        this.swiperxb = this.$refs.mySwiper.swiper.activeIndex
      },
      MenuState: function(xb) {
        this.Menuxb = xb
        var TypeID = this.MenuType[xb].TypeID
        var GoodsType = this.GoodsType
        var Sunlist = []
        if(this.MenuType[xb].IsRecommend){
        	var shuzu=this.MenuType[xb].GoodsID.split(',')
        	for(var j in shuzu){
        		for(var i in GoodsType){
        			if(GoodsType[i].GoodsID==shuzu[j]){
                GoodsType[i].src = this.$lujin + '/Data/' + this.ShopID + '/GoodsPic/' + GoodsType[i].GoodsID + '.jpg'
        				Sunlist.push(GoodsType[i])
        			}
        		}
        	}
        }else{
        	for (var i in GoodsType) {
        	  if (GoodsType[i].TypeID == TypeID) {
        	    GoodsType[i].src = this.$lujin + '/Data/' + this.ShopID + '/GoodsPic/' + GoodsType[i].GoodsID + '.jpg'
        	    Sunlist.push(GoodsType[i])
        	  }
        	}
        }
        this.Goodslist = Sunlist
        var Qua = Sunlist.length
        this.swiperQua = Qua % 9 == 0 ? parseInt(Qua / 9) : parseInt(Qua / 9) + 1
        this.swiperxb = 0
        this.touchStartedAtEnd = false
        this.touchStartedAtBeginning = false
        this.$nextTick(() => {
          const swiper = this.$refs.mySwiper && this.$refs.mySwiper.swiper
          if (!swiper) return
          swiper.slideTo(0, 0, false)
          swiper.update()
        })
      },
      GetSheetID: function() {
        var that = this
        this.axios.post(that.$lujin + "/api/default/TDeskzt?ShopID=" + this.ShopID + "&DeskID=" + this.DeskID)
          .then((res) => {
            console.log(res.data[0])
            //console.log(JSON.parse(res.data).Table[0])
            //console.log(this.SheetID)
            if (this.SheetID == undefined) {
              this.sheetzt = true
              console.log("失效1")
            }
            if (this.SheetID == res.data[0].SheetID) {
              console.log("有效期")
            }
            if (this.SheetID != undefined && this.SheetID != res.data[0].SheetID) {
              this.sheetzt = true
              Dialog.alert({
                title: '温馨提示',
                message: '二维码已经失效,请重新开台扫描平板上二维码!',
                confirmButtonText: '确定'
              }).then(() => {
                that.$router.go(-1)
              });
              console.log("失效2")
            }
          })
      }
    },
    mounted() {
      var that = this
      if (this.$route.query.Shopid == undefined) {
        return
      }
      if (this.$route.query.Shopid =="2505136688") {
        this.navtable="lll"
      }
	  if (this.$route.query.Shopid =="2025070210") {
	    this.navtable="yhd"
	  }
      this.ShopID = this.$route.query.Shopid
      this.DeskID = this.$route.query.id
      this.SheetID = this.$route.query.SheetID
      this.axios.get(this.$lujin + "/api/Default/cha_zuo?ShopID=" + this.ShopID + "&DeskID=" + this.DeskID)
        .then((res) => {
          console.log(res)
          console.log(res.data.data[0])
          console.log(res.data.data[0].Desk)
          that.Desk = res.data.data[0].Desk
        })
      this.axios.get(this.$lujin + '/api/Default/MenuType?ShopID=' + this.ShopID)
        .then((res) => {
          console.log(res.data)
          that.MenuType = res.data
          const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          const today = new Date();
          const Week = weekDays[today.getDay()];
          const WeekQua = today.getDay() == 0 ? 7 : today.getDay()
          let hh = new Date().getHours()
          let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
          let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
          var time = hh + ":" + mf + ":" + ss
          this.axios.get(this.$lujin + '/api/Default/Goods?ShopID=' + this.ShopID + "&Week=" + Week + "&Time=" +
              time + "&WeekQua=" + WeekQua)
            .then(pts => {
              console.log(pts)
              console.log(pts.data)
              that.GoodsType = pts.data
              document.getElementById("loader-wrapper").style.display="none"
              that.MenuState(0)
            })
        })
      this.GetSheetID()
      setInterval(() => {
        that.GetSheetID()
      }, 20000)
    }
  }
</script>

<style scoped>
  .index_xd2 {
    margin: .5rem auto 0 auto;
    width: 40%;
    height: .8rem;
    background: url(/static/images/sh/bababababab.png);
    background-size: 100% 100%;
    font-size:.36rem;
    font-weight:bold;
    text-align:center;
    line-height:.8rem;
    color:#fff;
  }
  .index_tips{
    width:90%;
    margin:.2rem auto;
    font-size:.3rem;
    font-weight:bold;
    line-height:.36rem;
    text-align:left;
  }
  .index_biaoge_right{
    width:20%;
    text-align: center;
    border-bottom:0.5px solid #999;
  }
  .index_biaoge_left2{
    width:80%;
    border-right:0.5px solid #999;
    border-bottom:0.5px solid #999;
    text-align:left;
    font-size:.3rem;
    text-indent:.2rem;
  }
  .index_biaoge_left{
    width:80%;
    border-right:0.5px solid #999;
    border-bottom:0.5px solid #999;
  }
  .index_biaoge_main_li{
    display:flex;
    height:.8rem;
    line-height:.8rem;
  }
  .index_biaoge_main{
    width:100%;
    height:9rem;
    overflow-y:scroll;
  }
  .index_biaoge_top{
    font-weight:bold;
    width:100%;
    display:flex;
    height:.8rem;
    line-height:.8rem;
  }
  .index_biaoge{
    width:90%;
    height:10rem;
    border-radius:0 0 .2rem .2rem;
    border:2px solid #000;
    box-sizing: border-box;
    background:#fff;
    margin:.1rem auto;
    font-size:.36rem;
  }
  .index_cxdd{
    width:90%;
    height:.5rem;
    line-height:.5rem;
    background:url(/static/images/sh/lists_top.png);
    background-size: 100% 100%;
    margin:0 auto 0 auto;
    font-size:.28rem;
    font-weight:bold;
    color:#fff;
  }
  .index_sfxd_butt div {
    background: url(/static/images/sh/bababababab.png);
    background-size: 100% 100%;
    width: 2.4rem;
    height: .8rem;
    line-height: .8rem;
    color: #fff;
  }

  .index_sfxd_butt {
    margin: .2rem 0 0 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .index_sfxd_table {
    line-height: 1rem;
  }

  .index_sfxd_main div {
    font-size: .4rem;
    font-weight: bold;
  }

  .index_sfxd_main {
    width: 84%;
    left: 8%;
    position: absolute;
    height: 2.4rem;
    background: #fff;
    border: 2px solid #000;
    top: 60%;
    border-radius: .3rem;
  }

  .index_sfxd {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
  }

  .index_xhc_img img {
    width: 100%;
    height: 100%;
    float: left;
  }

  .index_xhc_img {
    width: 23%;
    margin: 0 1%;
    height: .65rem;
  }

  .index_xhc_main {
    width: 57%;
    display: flex;
    margin: 0 auto;
  }

  .index_xd {
    margin: .2rem auto 0 auto;
    width: 33%;
    height: .72rem;
    background: url(/static/images/sh/shdcxd.png);
    background-size: 100% 100%;
  }

  @keyframes moveLeft {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0%);
    }
  }
  @keyframes moveRight {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
  .sh>.index_xhc4{
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background:rgba(0,0,0,0);
    background-size: 100% 100%;
  }
  .sh>.index_xhc4 .index_xhc_main{
    display:none;
  }
  .sh>.index_xhc3{
    animation: moveLeft 1s linear infinite;
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/sh/shdcxhc.png);
    background-size: 100% 100%;
  }
  .sh>.index_xhc2 {
    animation: moveRight 1s linear infinite;
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/sh/shdcxhc.png);
    background-size: 100% 100%;
  }
  .sh>.index_xhc {
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/sh/shdcxhc.png);
    background-size: 100% 100%;
  }

  .lll>.index_xhc4{
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background:rgba(0,0,0,0);
    background-size: 100% 100%;
  }
  .lll>.index_xhc4 .index_xhc_main{
    display:none;
  }
  .lll>.index_xhc3{
    animation: moveLeft 1s linear infinite;
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/lll/shdcxhc.png);
    background-size: 100% 100%;
  }
  .lll>.index_xhc2 {
    animation: moveRight 1s linear infinite;
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/lll/shdcxhc.png);
    background-size: 100% 100%;
  }
  .lll>.index_xhc {
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/lll/shdcxhc.png);
    background-size: 100% 100%;
  }

  .yhd>.index_xhc4{
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background:rgba(0,0,0,0);
    background-size: 100% 100%;
  }
  .yhd>.index_xhc4 .index_xhc_main{
    display:none;
  }
  .yhd>.index_xhc3{
    animation: moveLeft 1s linear infinite;
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/yhd/shdcxhc.png);
    background-size: 100% 100%;
  }
  .yhd>.index_xhc2 {
    animation: moveRight 1s linear infinite;
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/yhd/shdcxhc.png);
    background-size: 100% 100%;
  }
  .yhd>.index_xhc {
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/yhd/shdcxhc.png);
    background-size: 100% 100%;
  }

  .index_Goods_Goods .index_Goods_Goods2 {
    width: 100%;
    height: .4rem;
    line-height: .4rem;
    font-size: .2rem;
    background: #315858;
    color: yellow;
    border-radius: 0 0 .12rem .12rem;
    position:relative;
  }

  .index_Goods_Goods img {
    width: 100%;
    height: 100%;
    border-radius: .12rem .12rem 0 0;
  }

  .index_Goods_Goods .index_Goods_Goods1 {
    width: 100%;
    height: 1.3rem;
  }

  .index_Goods_Goods {
    width: 31.9%;
    margin: 0 0.7%;
    height: 1.8rem;
    position:relative;
  }

  .index_Goods_swiper {
    width: 100%;
	height:5.4rem;
    display: flex;
    flex-wrap: wrap;
	align-content: flex-start;
  }

  .index_Goods swiper {
    width: 100%;
  }
  .swiper-pagination{
    position:absolute;
    bottom:0;
    left:50%;
    width:100%;
    transform:translateX(-50%);
    height:18px;
    justify-content:center;
    display:flex;
  }
  .index_table_navbj {
    width: 100%;
    height: 100%;
    background: url(/static/images/sh/Menubj.png);
    background-size: 100% 100%;
    position: absolute;
    top: 0;
  }

  .index_table_navtext {
    font-size: .2rem;
    color: #fff;
    font-weight: bold;
    position: absolute;
    bottom:.04rem;
    width: 100%;
    text-align: center;
  }

  .index_table_navimg {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .index_table_nav2 {
    width: 40%;
    height: 1.32rem;
    margin-top: .1rem;
    font-size:0;
  }
  .index_table_nav2 img{
    width:100%;
    height:100%;
  }

  .index_table_navs {
    margin: 0 -2%;
    width: 24%;
    height: 1.3rem;
    position: relative;
  }

  .index_Goods {
    width: 98%;
    margin: 0 auto;
  }

  .index_table_nav {
    width: 96%;
    margin: 0 auto;
    display: flex;
  }

  .index_table {
    width: 95%;
    height: 10.2rem;
    margin: 0 auto;
    background: url(/static/images/sh/smdcbjbj.png);
    background-size: 100% 100%;
    position:relative;
  }

  .index_logo2 {
    width: 34.7%;
    height: .72rem;
    background: url(/static/images/sh/indexddxq.png);
    background-size: 100% 100%;
  }

  .index_logo1 {
    width: 59%;
    height: .72rem;
    font-size:0;
  }
  .index_logo1 img{
    width:100%;
    height:100%;
  }
  .index_logo {
    width: 95%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }

  .index_top {
    width: 100%;
    height: .8rem;
    line-height: .8rem;
    font-size: .4rem;
    text-align: center;
    font-weight: bold;
  }
  .index_main2{
    width: 100%;
    height: 100%;
    position:absolute;
    left:0;
    top:0;
  }
  .index_main {
    width: 100%;
    height: 100%;
  }
  #loader-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
  }
  .hydl{
	  width:40%;
	  height:0.8rem;
	  line-height:0.8rem;
	  margin:0.2rem 0 0 30%;
	  background:url(../../static/images/yhd/bababababab.png);
	  background-size:100% 100%;
	  font-size: .36rem;
	  color:#fff;
	  font-weight: bold;
  }
  #loader {
    display: block;
    position: relative;
    left: 50%;
    top: 50%;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border-radius: 50%;
    border: 3px solid transparent;
    /* COLOR 1 */
    border-top-color: orange;
    -webkit-animation: spin 2s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -ms-animation: spin 2s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -moz-animation: spin 2s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -o-animation: spin 2s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 2s linear infinite;
    /* Chrome, Firefox 16+, IE 10+, Opera */
    z-index: 1001;
  }
  #loader:before {
    content: "";
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    border-radius: 50%;
    border: 3px solid transparent;
    /* COLOR 2 */
    border-top-color: orange;
    -webkit-animation: spin 3s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -moz-animation: spin 3s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -o-animation: spin 3s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -ms-animation: spin 3s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 3s linear infinite;
    /* Chrome, Firefox 16+, IE 10+, Opera */
  }
  #loader:after {
    content: "";
    position: absolute;
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: orange;
    /* COLOR 3 */
    -moz-animation: spin 1.5s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -o-animation: spin 1.5s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -ms-animation: spin 1.5s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -webkit-animation: spin 1.5s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 1.5s linear infinite;
    /* Chrome, Firefox 16+, IE 10+, Opera */
  }
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(0deg);
      /* IE 9 */
      transform: rotate(0deg);
      /* Firefox 16+, IE 10+, Opera */
    }
    100% {
      -webkit-transform: rotate(360deg);
      /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(360deg);
      /* IE 9 */
      transform: rotate(360deg);
      /* Firefox 16+, IE 10+, Opera */
    }
  }
  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(0deg);
      /* IE 9 */
      transform: rotate(0deg);
      /* Firefox 16+, IE 10+, Opera */
    }
    100% {
      -webkit-transform: rotate(360deg);
      /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(360deg);
      /* IE 9 */
      transform: rotate(360deg);
      /* Firefox 16+, IE 10+, Opera */
    }
  }
  #loader-wrapper .loader-section {
    position: fixed;
    top: 0;
    width: 51%;
    height: 100%;
    background: #FFF;
    /* Old browsers */
    z-index: 1000;
    -webkit-transform: translateX(0);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: translateX(0);
    /* IE 9 */
    transform: translateX(0);
    /* Firefox 16+, IE 10+, Opera */
  }
  #loader-wrapper .loader-section.section-left {
    left: 0;
  }
  #loader-wrapper .loader-section.section-right {
    right: 0;
  }
  /* Loaded */
  .loaded #loader-wrapper .loader-section.section-left {
    -webkit-transform: translateX(-100%);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: translateX(-100%);
    /* IE 9 */
    transform: translateX(-100%);
    /* Firefox 16+, IE 10+, Opera */
    -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
  }
  .loaded #loader-wrapper .loader-section.section-right {
    -webkit-transform: translateX(100%);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: translateX(100%);
    /* IE 9 */
    transform: translateX(100%);
    /* Firefox 16+, IE 10+, Opera */
    -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
  }
  .loaded #loader {
    opacity: 0;
    -webkit-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
  }
  .loaded #loader-wrapper {
    visibility: hidden;
    -webkit-transform: translateY(-100%);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: translateY(-100%);
    /* IE 9 */
    transform: translateY(-100%);
    /* Firefox 16+, IE 10+, Opera */
    -webkit-transition: all 0.3s 1s ease-out;
    transition: all 0.3s 1s ease-out;
  }
  /* JavaScript Turned Off */
  .no-js #loader-wrapper {
    display: none;
  }
  .no-js h1 {
    color: #222222;
  }
  #loader-wrapper .load_title {
    font-family: 'Open Sans';
    color: orange;
    font-size: 19px;
    width: 100%;
    text-align: center;
    z-index: 9999999999999;
    position: absolute;
    top: 70%;
    opacity: 1;
    line-height: 30px;
  }
  #loader-wrapper .load_title span {
    font-weight: normal;
    font-style: italic;
    font-size: 13px;
    color: #FFF;
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/shdc.vue